function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M80.508.02C36.047.02-.007 36.066-.007 80.535c0 35.573 23.07 65.753 55.061 76.4 4.024.745 5.501-1.747 5.501-3.874 0-1.918-.074-8.262-.109-14.99-22.4 4.87-27.126-9.5-27.126-9.5-3.662-9.305-8.94-11.78-8.94-11.78-7.305-4.998.551-4.895.551-4.895 8.085.568 12.342 8.298 12.342 8.298 7.182 12.308 18.836 8.75 23.43 6.692.724-5.203 2.81-8.756 5.112-10.766-17.883-2.035-36.683-8.94-36.683-39.791 0-8.79 3.146-15.973 8.296-21.612-.836-2.028-3.592-10.217.781-21.307 0 0 6.762-2.163 22.146 8.254 6.423-1.784 13.31-2.679 20.153-2.71 6.843.031 13.736.926 20.17 2.71 15.368-10.417 22.12-8.254 22.12-8.254 4.382 11.09 1.627 19.28.79 21.307 5.163 5.639 8.286 12.822 8.286 21.612 0 30.925-18.836 37.733-36.765 39.727 2.888 2.498 5.461 7.398 5.461 14.91 0 10.773-.092 19.443-.092 22.095 0 2.144 1.448 4.654 5.53 3.864 31.975-10.658 55.016-40.828 55.016-76.39 0-44.47-36.049-80.515-80.516-80.515",
  fill: "#1b1817",
  fillRule: "evenodd"
});

function SvgGithubFileArtifact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161.03,
    height: 157.06,
    viewBox: "0 0 161.035 157.058"
  }, props), _ref);
}

export default __webpack_public_path__ + "github-file-artifact.b8ec6.svg";
export { SvgGithubFileArtifact as ReactComponent };